import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AlternateNonUsf,
  NonUsfRadioItem,
} from '@inventory/pages/manage-non-usf-products/models/non-usf-products-view-model';
import { PlatformEnum } from '@panamax/app-state';
import { Product } from '@shared/models/product.model';

@Component({
  selector: 'app-multi-select-non-usf-button',
  templateUrl: './multi-select-non-usf-button.component.html',
  styleUrls: ['./multi-select-non-usf-button.component.scss'],
})
export class MultiSelectNonUsfButtonComponent {
  @Input() nonUsfProduct: Product;
  @Input() index: number;

  @Output()
  selectNonUsfProductEmitter: EventEmitter<Product> = new EventEmitter();

  readonly platformRef = PlatformEnum;

  constructor() {}

  selectNonUsfProduct() {
    this.selectNonUsfProductEmitter.emit(this.nonUsfProduct);
  }
}
